<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="function-wrap">
      <h1>{{ '批量复制平台考核规则' }}</h1>
      <div class="back-btn" @click="$router.go(-1)">返回</div>
    </div>
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">考核内容：</div>
          <el-input size="mini" v-model="page.evaluationContent" class="ipt-sty" placeholder="请输入考核内容"></el-input
        ></el-col>
        <el-col :span="8"
          ><div class="search-area-div">考核要求：</div>
          <el-input size="mini" v-model="page.evaluationRuleDesc" class="ipt-sty" placeholder="请输入考核内容"></el-input
        ></el-col>
        <div style="float: left">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </div>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <!-- <el-button size="mini" type="info" @click="toBulkCopy">批量复制</el-button> -->
        <el-button size="mini" type="info" @click="allCopy">一键复制</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" v-loading="tableLoading" :height="height">
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="campaignsState"
          label="考核内容"
          show-overflow-tooltip
          header-align="center"
          width="140"
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.evaluationContent }}</template>
        </el-table-column>
        <el-table-column label="考核类型" width="140" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.evaluationType === '1' ? '数量要求' : '质量要求' }}
          </template>
        </el-table-column>
        <el-table-column prop="isPass" width="100" label="是否合格" header-align="center" align="left">
          <template slot-scope="scope">{{ isPass(scope.row.isPass) }}</template>
        </el-table-column>
        <el-table-column prop="evaluationRuleDesc" show-overflow-tooltip width="200" label="考核要求" header-align="center" align="left">
        </el-table-column>
        <el-table-column prop="minQuantity" width="140" label="最低数量要求" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.minQuantity | numDigit }}</template>
        </el-table-column>
        <el-table-column prop="cutPayment" width="140" label="扣罚金额(元)" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.cutPayment | numDigit }}</template>
        </el-table-column>
        <el-table-column prop="award" width="140" label="奖励金额(元)" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.award | numDigit }}</template>
        </el-table-column>
        <el-table-column prop="cutRate" width="140" label="扣罚比例(%)" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.cutRate | numDigit }}</template>
        </el-table-column>
        <el-table-column prop="awardRate" width="140" label="奖励比例(%)" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.awardRate | numDigit }}</template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[50, 100, 200, 500]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="dialogTxt" :visible.sync="dialogCheckVisible" width="500px">
      <div slot="title" class="dialog-title">
        {{ '复制考核规则' }}
      </div>
      <div class="dialogCon">
        <!-- 原因说明 -->
        <div class="dialogCon-describe">
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="import_new_wrap">
                <div class="import-dialog-title">
                  <img src="../../assets/icon/import_warning.png" alt="" />说明: 该功能支持批量复制规则给其他服务商
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="search-area-div">{{ `已选择规则: ${copyType === 'select'? multipleSelection.length : allEvaluationGuids.length}条` }}</div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24" style="display:flex">
              <div class="search-area-div">{{ '应用服务商: ' }}</div>
              <el-select style="width:384px" v-model="tenantGuids" collapse-tags filterable reserve-keyword clearable multiple placeholder="请选择">
                <el-option v-for="item in tenantList" :label="item.tenantName" :value="item.guid" :key="item.guid">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCheckVisible = false">取 消</el-button>
        <el-button size="small" v-loading.fullscreen.lock="fullscreenLoading" type="info" @click="submit2">复 制</el-button>
      </span>
    </el-dialog>

    <!-- 内层dialog -->
      <el-dialog
        width="500px"
        title="特别提醒"
        :visible.sync="innerVisible"
        append-to-body>
        <div class="dialogCon">
          <!-- 原因说明 -->
          <div class="dialogCon-describe">
            <el-row :gutter="24">
              <el-col :span="24">
                <div class="import_new_wrap">
                  <div class="import-dialog-title">
                    <img src="../../assets/icon/import_warning.png" alt="" />以下规则已存在，确定覆盖吗?
                  </div>
                </div>
              </el-col>
            </el-row>
            <div class="content-main-box" style="height:100%;padding-top:10px">
              <el-table :data="ruleList" stripe border max-height="400" style="width: 100%">
                <el-table-column 
                  prop="col1"
                  label="应用项目"
                  show-overflow-tooltip
                  header-align="left"
                  align="left"
                  width="180"
                > 
                </el-table-column>
                <el-table-column
                  prop="col2"
                  label="规则名称"
                  show-overflow-tooltip
                  header-align="left"
                  align="left"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="innerVisible = false">取消</el-button>
          <el-button size="small" type="info"  @click="copyDetail">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import { reject } from 'lodash';
export default {
  data() {
    return {
      tenantGuids: [],
      tenantList: [],
      multipleSelection:[], // 勾选内容
      fullscreenLoading: false,
      textTitle: '新增任务大类',
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: localStorage.guid,
        evaluationContent: '',
      },
      evaluationContent: '',
      orderNum: '',
      height: window.innerHeight - 300,
      contentMainHeight: window.innerHeight - 250,
      right: 'right',
      tableData: [],
      dialogVisible: false,
      innerVisible:false, // 内层dialog
      ruleList:[], // 重复规则list
      dialogTxt: '设置考核机制',
      dialogCheckVisible: false,
      allEvaluationGuids: [], // 所有规则
      taskEvaluationGuid: '',
      evaluationTypeList: [
        { label: '数量要求', value: '1' },
        { label: '质量要求', value: '2' },
      ],
      isPassList: [
        { label: '合格', value: 'Y' },
        { label: '部分合格', value: 'P' },
        { label: '不合格', value: 'N' },
      ],
      copyType:'' // select 勾选复制 all 所有
    };
  },
  created() {
    this.getList();
    this.getAllList()
    this.getTenantList();
  },
  watch: {
    dialogCheckVisible() {
      this.tenantGuids = []
    }
  },
  methods: {
    isPass(val) {
      if(!val){
        return '-';
      };
      const passTextMap = {
        Y: '合格',
        P: '部分合格',
        N: '不合格',
      }
      return passTextMap[val] || '-';
    },
    // todo 批量复制
    toBulkCopy() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请先勾选数据');
        return
      }
      this.copyType = 'select'
      this.dialogCheckVisible = true
    },
    // todo 一键复制
    allCopy() {
      this.copyType = 'all'
      this.dialogCheckVisible = true
    },
    // 判断服务商是否存在平台规则
    hasRule() {
      return new Promise((resolve,reject)=>{
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/get-exist-msg`, this.tenantGuids).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let topic = res.data.data
            resolve(topic)
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
    },
    // todo 确认复制
   async submit() {
      if (!this.tenantGuids.length) {
        this.$message.warning('请选择服务商');
        return
      }
      let res = await this.hasRule()
      if (!res) {
        this.copyDetail()
        return
      }
      this.$confirm(res, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.copyDetail()
        }).catch(() => {
          
        });
    },
     // todo 确认复制
   async submit2() {
      if (!this.tenantGuids.length) {
        this.$message.warning('请选择服务商');
        return
      }
      let param = {
        sourceTenantGuid:localStorage.guid, // 源企业
        targetTenantGuidList:this.tenantGuids, // 目标企业
        ruleGuidList:this.copyType === 'select' ? this.multipleSelection.map(item=>item.guid) : this.allEvaluationGuids // 
      }
      if (this.copyType === 'select') { // 批量复制逻辑
        let res = await this.getRepeatInfoPromise(param)
        if (res.length) {
          this.innerVisible = true
        } else {
          this.copyDetail(param)
        }
      } else if (this.copyType === 'all') {
        this.copyDetail(param)
      }
    },
    // 获取平台重复规则服务
    getRepeatInfoPromise(param) {
      return new Promise((resolve,reject)=>{
        this.api.postJson(`/${serverConfig.msSalesPerformService}/task/evaluation/detail/get-repeat-info`, param).then((res) => {
          this.fullscreenLoading = false
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (Array.isArray(res.data.data) && res.data.data.length) {
              this.innerVisible = true
              this.ruleList = res.data.data
              resolve(res.data.data)
            } else {
              this.ruleList = []
              resolve([])
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
    },
    copyDetail() {
      this.fullscreenLoading = true
      let param = {
        sourceTenantGuid:localStorage.guid, // 源企业
        targetTenantGuidList:this.tenantGuids, // 目标企业
        ruleGuidList:this.copyType === 'select' ? this.multipleSelection.map(item=>item.guid) : this.allEvaluationGuids // 
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/copy-detail`, param).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.fullscreenLoading = false
          this.dialogCheckVisible = false
          this.innerVisible = false
          this.$message.success('复制成功');
        } else {
          this.$message.error(res.data.msg);
        }
      });
      this.dialogCheckVisible = false;
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    getTenantList() {
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901'],
      };
      this.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.tenantList = res.data.data.records || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    search() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        evaluationContent: '',
        evaluationRuleDesc:'',
        tenantGuid: localStorage.guid,
      };
      this.getList();
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAllList() {
      let param = {
        tenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: -1,
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/content/detail/list`, param).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.allEvaluationGuids = res.data.data.records.map(item=>item.guid);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

/* 弹框样式 */
/deep/.el-dialog__footer {
  padding: 10px 20px 10px;
  border-top: 1px solid #d9d9d9;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 10px 15px;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.dialogCon {
  border-top: 1px solid #dcdee0;
  text-align: left;
  padding: 10px 20px;
}
.content h1 {
  margin: 0;
  font-size: 18px;
}
.function-wrap {
  position: relative;
  /* height: 50px; */
  line-height: 50px;
  /* padding: 10px 20px; */
  box-sizing: border-box;
  text-align: center;
  border-bottom: 1px solid #D9D9D9;
  background: #fff;
}
.back-btn {
  position: absolute;
  top: 14px;
  left: 10px;
  width: 64px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #c8c9cd;
}
</style>
<style scoped>
.check-table-input .el-input__inner {
  text-align: right !important;
}
.import_new_wrap {
  padding: 0;
  border: 0;
}
</style>
